import React from 'react'
import styles from './CommonFooter.module.scss'
import IcoonPrivacy from '../../../../../../assets/images/spa/common/icon_privacy.png'

export const StyledCommonFooter: React.FC = () => {
  const isHome = () => {
    return location.pathname === '/'
  }

  return (
    <footer className={`${styles.productFooter} ${isHome() ? '-top' : ''}`}>
      <div className={`${styles.productFooter__inner}`}>
        <div className={`${styles.productFooter__cont}`}>
          <p className={`${styles.productFooter__copy}`}>copyright (c) CrowdWorks Inc. all rights reserved.<br/>運営会社：株式会社クラウドワークス
          </p>
          <div className={`${styles.productFooter__privacy}`}>
            <p>
              <a href="https://crowdworks.co.jp/privacy_policy/" target="_blank">個人情報保護方針</a>
            </p>
            <img src={IcoonPrivacy} alt="プライバシーマーク"/>
          </div>
        </div>
      </div>
    </footer>
  )
}
